import Entity from '../entity'

export default class JobAction extends Entity<number> {
    jobId: number;
    actionId: number;
    actionName: string;
    note: string;
}
